module.exports = __webpack_public_path__ + "static/media/1-active.f82957fe.png";